import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import {
  Table, Switch, Button, Drawer,
} from 'antd';
import {
  EditOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import ProductActions from '@Actions/productActions';
import SellerActions from '@Actions/sellerActions';
import Helpers from '@Apis/helpers';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import imageDefault from '@Images/icons/imageDefault.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import { H3_TITLE } from '@Apis/constants';
import closeIcon from '@Images/icons/icon-close-blue.png';
import ProductForm from '@Components/Common/ProductForm';
import './style.scss';
import OfferForm from '../../../Common/Form/OfferForm';
import ActivityLogActions from '@Actions/activityLogActions';
import ActivityLog from '../../../Common/ActivityLog';

/**
 *
 */
class VendorProducts extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      productListColumns: [{
        title: '',
        render: (record) => (
          <div
            className="mobile-list__item"
            onClick={() => this.setState({ openPurchaseOrderModal: true, selectedOffer: record })}
          >
            <div style={{ display: 'flex' }}>
              <H3Text text={`#${record?.product_info?.product_sku_name}`} className="mobile-list__item-number" />
              <div style={{ marginLeft: 'auto' }} className={`inactive-chip ${record?.is_active ? 'active-chip' : ''}`}>
                {record?.is_active ? 'Active' : 'Inactive'}
              </div>
            </div>
            <H3Text text={`Vendor Price - ${this.props.MONEY(record?.offer_price || '0')}`} className="mobile-list__item-info" />
            <H3Text text={`MOQ - ${(record?.moq || '0')} ${record?.product_info?.uqc?.toProperCase()}`} className="mobile-list__item-info" />
          </div>
        ),
        responsive: ['xs'],
      },
      {
        title: '',
        key: 'asset_1',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
                        record?.product_info?.assets?.[0]?.url
                          ? <H3Image src={`${record?.product_info?.assets?.[0]?.url}`} className="prod-table__image" />
                          : <H3Image src={imageDefault} className="prod-table__image prod-table__image__default" />
        ),
      },
      {
        title: 'PRODUCT NAME',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <H3Text text={`${record?.product_info?.product_sku_name}`} className="prod-table__text" />
        ),
      },
      {
        title: 'VENDOR PRICE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <React.Fragment>
            <div>
              {this.props.MONEY(record?.offer_price || '0')}
            </div>
          </React.Fragment>
        ),
      },
      {
        title: 'MOQ',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <React.Fragment>
            <div>
              {record?.moq}
              {' '}
              {record?.product_info?.uqc?.toProperCase()}
            </div>
          </React.Fragment>
        ),
      },
      {
        title: 'STATUS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <div className="status">
            <div className={`inactive-chip ${record?.is_active ? 'active-chip' : ''}`}>
              {record?.is_active ? 'Active' : 'Inactive'}
            </div>
          </div>
        )
        ,
      },
      {
        title: '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <div className="status">
            {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PRICE,
              Helpers.permissionTypes.UPDATE, this.props.user) && (
              <div
                onClick={() => {
                  this.setState({
                    openPurchaseOrderModal: true, selectedOffer: record, isEditing: true, isFromVendor: true,
                  });
                }}
                className="roundIconButton"
              >
                <EditOutlined />
              </div>
              
            )}
            <div className= 'roundIconButton' onClick={() => {
                  this.setState({
                    openOfferLog: true,
                    selectedOffer: record,
                  });
                }}>
                  <HistoryOutlined />
            </div>
            {/* {Helpers.getPermission(Helpers.permissionEntities.PRODUCT, */}
            {/*  Helpers.permissionTypes.UPDATE, this.props.user) && ( */}
            {/*  <Switch */}
            {/*    onChange={() => this.toggleActivate({ */}
            {/*      offer_price: record?.offer_price, */}
            {/*      moq: record?.moq, */}
            {/*      packaging_details: [null, 'null'].includes(record?.packaging_details) ? record?.packaging_details : '', */}
            {/*      sku_offer_id: record?.sku_offer_id, */}
            {/*    }, record.is_active)} */}
            {/*    checked={record?.is_active} */}
            {/*  /> */}
            {/* )} */}
          </div>
        )
        ,
      },
      ],
      selectedOffer: {},
      showNewProductModal: false,
      showNewOfferModal: false,
      product: '',
      limit: 20,
      currentPage: 1,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      match, user, getSellerProducts,
    } = this.props;
    const { currentPage, limit } = this.state;
    const { vendorId } = match.params;
    getSellerProducts(user?.tenant_info?.tenant_id, vendorId, '', currentPage, limit);
  }

  /**
   *
   * @param payload
   */
  handelUpdateSellerOffer(payload) {
    const {
      updateSellerOffers, getSellerProducts, user, match,
    } = this.props;
    const { currentPage, limit } = this.state;
    const { vendorId } = match.params;
    updateSellerOffers([payload], () => {
      getSellerProducts(user?.tenant_info?.tenant_id, vendorId, '', currentPage, limit);
      this.toggleModel();
    });
  }

  /**
   *
   */
  toggleModel() {
    this.setState({ openPurchaseOrderModal: false });
  }

  /**
   * @param payload
   * @param isActive
   * @param is_active
   */
  toggleActivate(payload, isActive) {
    const newPayload = payload;
    if (isActive) {
      newPayload.is_active = false;
    } else {
      newPayload.is_active = true;
    }
    this.handelUpdateSellerOffer(newPayload);
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      getProductsLoading, getSellerProducts, getSellerProductsLoading,
      updateSellerOffersLoading, getSellerOffersById, match, user, products, sellerProducts, selectedSeller,
    } = this.props;
    const {
      productListColumns, openPurchaseOrderModal, showNewProductModal,
      productSkuId, showNewOfferModal, product, currentPage, selectedOffer,
      limit, isEditing, isFromVendor, openOfferLog
    } = this.state;
    const { vendorId } = match.params;

    return (
      <Fragment>
        <Drawer
          open={showNewOfferModal}
          onClose={() => {
            this.setState({
              showNewProductModal: false, showNewOfferModal: false, product: '', productSkuId: '',
            });
          }}
          width="420px"
          destroyOnClose
        >
          <OfferForm
            marketplace={selectedSeller?.seller_info?.is_marketplace_seller}
            setShowNewProductModal={(value) => this.setState({ showNewProductModal: value })}
            callback={
              () => {
                this.setState({
                  showNewProductModal: false, showNewOfferModal: false, product: '', productSkuId: '',
                });
                getSellerProducts(user?.tenant_info?.tenant_id, vendorId, '', currentPage, limit);
              }
            }
            product={product}
            productSkuId={productSkuId}
            setProduct={(value) => this.setState({ product: value })}
            setProductSkuId={(value) => this.setState({ productSkuId: value })}
            selectedSeller={selectedSeller}
            toggleNewOfferModal={() => this.setState({ showNewOfferModal: false })}
            isEditing={isEditing}
            isFromVendor={isFromVendor}
          />
          <div>
            <Drawer
              open={showNewProductModal}
              onClose={() => {
                this.setState({ showNewProductModal: false });
              }}
              width="520px"
              closable={false}
              destroyOnClose
            >
              <div className="custom-drawer__header-wrapper">
                <div className="custom-drawer__header" style={{ width: '475px' }}>
                  <H3Text text="Add New Product" className="custom-drawer__title" />
                  <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewProductModal: false })} />
                </div>
              </div>
              <ProductForm
                callback={(prd) => {
                  this.setState({
                    showNewProductModal: false, showNewOfferModal: true, product: prd.product_sku_name, productSkuId: prd.product_sku_id,
                  });
                  getSellerProducts(user?.tenant_info?.tenant_id, vendorId, '', currentPage, limit);
                }}
              />
            </Drawer>
          </div>
        </Drawer>
        <Drawer
          open={openOfferLog}
          destroyOnClose
          footer={null}
          width="360px"
          onClose={
            () => this.setState({
              openOfferLog: null,
            })
          }>
            <ActivityLog
              entityId={selectedOffer?.sku_offer_id}
              entityType="sku_offer"
              entityName="SKU Offer"
            />
        </Drawer>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <div className="vendor-products__wrapper">
          <div className="generic-table-container">
            <Table
              loading={getSellerProductsLoading || updateSellerOffersLoading}
              showHeader
              size="small"
              scroll="scroll"
              columns={productListColumns}
              dataSource={sellerProducts?.result?.products || []}
              title={() => (
                <div className="view-vendor__add-offer">
                  {`${sellerProducts?.count || '0'} Products Offered by Vendor`}
                  {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PRICE,
                    Helpers.permissionTypes.CREATE, this.props.user) && (
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ Add Vendor Price"
                      onClick={() => this.setState({ showNewOfferModal: true, isEditing: false, isFromVendor: true })}
                      customClass="view-vendor__add-offer__button"
                    />
                  )}
                </div>
              )}
              pagination={{
                pageSize: limit,
                total: sellerProducts?.count,
                current: currentPage,
                position: ['bottomLeft'],
                showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                showSizeChanger: false,
                onChange: (page, pgSize) => {
                  this.setState({ currentPage: page, limit: pgSize });
                  getSellerProducts(user?.tenant_info?.tenant_id, vendorId, '', page, limit);
                },
              }}
            />

          </div>
        </div>

        <Drawer
          title="Update Product Price"
          open={openPurchaseOrderModal}
          // onClose={() => this.toggleModel()}
          onClose={() => {
            this.toggleModel();
            this.setState({
              showNewProductModal: false, showNewOfferModal: false, product: '', productSkuId: '',
            });
          }}
          width="420px"
          destroyOnClose
        >
          <OfferForm
            product={selectedOffer?.product_info?.product_sku_name}
            selectedOffer={selectedOffer}
            callback={() => {
              this.setState({
                openPurchaseOrderModal: false,
              });
              getSellerProducts(user?.tenant_info?.tenant_id, vendorId, '', currentPage, limit);
            }}
            isEditing={isEditing}
            isFromVendor={isFromVendor}
            toggleNewOfferModal={() => this.setState({ openPurchaseOrderModal: false })}
          />
        </Drawer>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  SellerReducers, UserReducers, ProductReducers,
}) => ({
  getSellerByIdLoading: SellerReducers.getSellerByIdLoading,
  selectedSeller: SellerReducers.selectedSeller,
  updateSellerOffersLoading: SellerReducers.updateSellerOffersLoading,
  selectedSellerOffers: SellerReducers.selectedSellerOffers,
  getSellerOffersByIdLoading: SellerReducers.getSellerOffersByIdLoading,
  pincodeCity: SellerReducers.pincodeCity,
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  sellerProducts: ProductReducers.sellerProducts,
  getSellerProductsLoading: ProductReducers.getSellerProductsLoading,

});

const mapDispatchToProps = (dispatch) => ({
  getSellerById: (vendorId, tenantId) => dispatch(SellerActions.getSellerById(vendorId, tenantId)),
  updateSeller: (payload) => dispatch(SellerActions.updateSeller(payload, '')),
  updateSellerOffers: (payload, callback) => dispatch(SellerActions.updateSellerOffers(payload, callback)),
  getSellerOffersById: (vendorId, page) => dispatch(SellerActions.getSellerOffersById(vendorId, page)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  getSellerProducts: (tenantId, sellerId, productName, page, limit) => dispatch(ProductActions.getSellerProducts(tenantId, sellerId, productName, page, limit)),
  getActivityLogSuccess: (activityLog) => dispatch(ActivityLogActions.getActivityLogSuccess(activityLog))
});

VendorProducts.propTypes = {
  user: PropTypes.any,
  getSellerProducts: PropTypes.func,
  sellerProducts: PropTypes.any,
  getSellerProductsLoading: PropTypes.bool,
  match: PropTypes.any,
  selectedSeller: PropTypes.any,
  updateSellerOffers: PropTypes.func,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VendorProducts));
